import type { ReactNode } from 'react';

interface TeamFlagProps {
  team: 'USA' | 'EU' | 'EUR';
}

const usFlag = (
  <img
    src="https://flagcdn.com/us.svg"
    alt="US"
    style={{ width: '48px', height: '36px', imageRendering: 'crisp-edges' }}
  />
);

const euFlag = (
  <img
    src="https://flagcdn.com/eu.svg"
    alt="EU"
    style={{ width: '48px', height: '36px', imageRendering: 'crisp-edges' }}
  />
);

export const TeamFlag = ({ team }: TeamFlagProps): ReactNode => {
  return team === 'EUR' || team === 'EU' ? euFlag : usFlag;
};
